export const adsComparisonSelectedOptionsValidator = options => options && options?.length > 1 && options?.length < 6;
